// extracted by mini-css-extract-plugin
export default {"container":"T8_tYg4G9IPreI8S7xDk"};